import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { memberDetailsReducer } from './member-details/state/member-details.reducer';
import { memberSearchReducer } from './member-search/state/member-search.reducer';
import { FEATURE_NAME, IMemberState } from './member.model';

export const selectMemberFeature = createFeatureSelector<IMemberState>(FEATURE_NAME);

export const memberFeatureReducers: ActionReducerMap<IMemberState> = {
  memberSearchState: memberSearchReducer,
  memberDetailsState: memberDetailsReducer
};
